if (!customElements.get('subscription-popup')) {
  customElements.define(
    'subscription-popup',
    class SubscriptionPopup extends DrawerComponent {
      static get observedAttributes() {
        return super.observedAttributes.concat(['data-trigger-open', 'data-repeat-open']);
      }

      constructor() {
        super();
      }

      get requiresBodyAppended() {
        return false;
      }

      connectedCallback() {
        super.connectedCallback();

        this.triggerOpen = this.dataset.triggerOpen;
        this.repeatOpen = this.dataset.repeatOpen;
        this.cookieName = 'sleektheme:popup';

        window.FoxTheme.DOMready(this.handleOpen.bind(this));

        window.FoxTheme.utils.addEventDelegate({
          context: this,
          selector: '.btn-apply-coupon-code',
          handler: async (e, target) => {
            e.preventDefault();
            const code = target.dataset.code;
            if (code) this.copyToClipboard(code, target);
          },
        });

        // EP: la barre d'annonce (lien newsletter) ouvre ce pop-up sur toutes les pages, PC et mobile.
        // Écoute en phase de capture pour passer avant le slider (Swiper) et le défilement d'ancre du thème.
        document.addEventListener(
          'click',
          (e) => {
            const link = e.target.closest(
              'a[href$="#ContactSubscribe-newsletter_main"], [data-ep-open-newsletter]'
            );
            if (!link) return;
            if (!link.closest('.announcement-bar') && !link.hasAttribute('data-ep-open-newsletter')) return;
            e.preventDefault();
            e.stopPropagation();
            this.show();
          },
          { signal: this.abortController.signal, capture: true }
        );
      }

      prepareToShow() {
        super.prepareToShow();
        this.setRepeatOpen();
      }

      isLoggedInCustomer() {
        try {
          const sa = window.ShopifyAnalytics;
          if (sa && sa.meta && sa.meta.page && sa.meta.page.customerId) return true;
          if (window.__st && window.__st.cid) return true;
        } catch (err) {}
        return false;
      }

      handleOpen() {
        if (Shopify.designMode) return;

        // EP: ouverture automatique uniquement sur la page d'accueil
        if (!document.body.classList.contains('index-template')) return false;

        // EP: pas d'ouverture automatique pour les clients connectés (le clic sur la barre d'annonce reste actif)
        if (this.isLoggedInCustomer()) return false;

        let savedData = FoxTheme.utils.getStorage(this.cookieName);
        if (savedData && savedData.opened) {
          return false;
        }

        switch (this.triggerOpen) {
          case 'delay':
            setTimeout(() => {
              this.show();
            }, 5000);
            break;
          case 'scroll_down':
            this.triggerAfterScroll(700, this.show.bind(this));
            break;
          default:
            this.show();
            break;
        }
      }

      triggerAfterScroll(offset = 500, trigger) {
        let opened = false;
        const start = 0;
        window.addEventListener('scroll', (e) => {
          let scrollTop =
            window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;

          if (scrollTop - start > offset && !opened) {
            trigger();
            opened = true;
            return;
          }
        });
      }

      copyToClipboard(code, button) {
        navigator.clipboard.writeText(code);
        button.innerText = button.dataset.copiedText;
      }

      setRepeatOpen() {
        if (Shopify.designMode) return;

        let expires;
        switch (this.repeatOpen) {
          case 'no_repeat':
            expires = 365;
            break;
          case 'every_3_mins':
            expires = 3 / 60 / 24;
            break;
          case 'every_5_mins':
            expires = 5 / 60 / 24;
            break;
          case 'every_10_mins':
            expires = 1 / 6 / 24;
            break;
          case 'every_15_mins':
            expires = 15 / 60 / 24;
            break;
          case 'every_30_mins':
            expires = 1 / 2 / 24;
            break;
          case 'every_1_hr':
            expires = 1 / 24;
            break;
          case 'every_6_hrs':
            expires = 6 / 24;
            break;
          case 'every_12_hrs':
            expires = 1 / 2;
            break;
          case 'every_day':
            expires = 1;
            break;
          case 'every_3_days':
            expires = 3;
            break;
          case 'every_week':
            expires = 7;
            break;
          case 'every_2_weeks':
            expires = 14;
            break;
          case 'every_month':
            expires = 30;
            break;
          default:
            expires = 7;
            break;
        }

        window.FoxTheme.utils.setStorage(this.cookieName, { opened: true }, expires);
      }
    }
  );
}
